// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","item":"item-13kc4","count":"count-2AaVz","counts":"counts-1XqvP","root":"root-16EmV"};